import React from 'react'
import noDraftChallangee from 'img/no_Draft_challangee.png'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  noIdeaImg: {
    marginTop:theme.spacing(2),
    height: '288px',
  },
  noIdeas: {
    fontFamily:theme.fontFamily.fontFamilyRegular,
    fontSize:theme.fontSize.fontsize32,
      color: '#333333',
  },
 
}));



const EmptyState = (props) => {
  const classes = useStyles();
  return(
  
  <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
    <img className={classes?.noIdeaImg} src={noDraftChallangee} alt='no challenge' />
    <p className={classes?.noIdeas}>No existing <span className={classes?.purpleNo}>Challenges</span></p>
  </div>
  )
}

export default EmptyState
